// extracted by mini-css-extract-plugin
module.exports = {"tabBar":"tab-bar_tabBar__e7iay","tabList":"tab-bar_tabList__enqJi"};